// extracted by mini-css-extract-plugin
export default {"ohHovertab":"SearchpageStyles_ohHovertab__LP2p-","onSelectedtab":"SearchpageStyles_onSelectedtab__SKF1o","numberAvatar":"SearchpageStyles_numberAvatar__79Fg1"};